// src/pages/FavoritesPage.js
import React from 'react';
import Favorites from '../components/Favorites';

const FavoritesPage = () => {
    return (
        <div>
            {/* <h1>Favorites Page</h1> */}
            <Favorites />
        </div>
    );
};

export default FavoritesPage;